import { ArrowDownIcon } from '@heroicons/react/24/outline';
import Link from 'next/link';
import { generateButtonClassNames } from 'ui';
import { RailsBlock } from '~/typings/services/rails/tile';

export default function ContentPreviewBlock({ block }: { block: RailsBlock }) {
  return (
    <div className="container">
      <div
        className="bg-pastel-green-300 rounded px-4 py-2.5"
        style={{
          backgroundColor: block.background_color,
        }}
      >
        <div className="flex flex-col items-center gap-4 md:flex-row">
          <div className="flex-1">
            <div className="mb-2 font-semibold">{block.title}</div>
            <div className="text-sm">{block.description}</div>
          </div>

          <div className="flex-shrink-0">
            <Link
              href="#collapsible-content-header"
              className={generateButtonClassNames({
                variant: 'outlined',
                className: 'inline-flex items-center gap-2 bg-white',
              })}
            >
              <span>Read Full Guide</span>
              <ArrowDownIcon className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
